document.addEventListener("DOMContentLoaded", () => {
  const typingText = document.querySelector(".lukuku-blog__title-main");
  const typingTextSecondary = document.querySelector(
    ".lukuku-blog__title-secondary"
  );

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: document.querySelector(".lukuku-blog"),
      start: "top center",
      toggleActions: "play none none reverse",
    },
  });

  tl.to(typingText, {
    yPercent: 0,
    opacity: 1,
    duration: 0.5,
    ease: "power3.out",
    onStart: () => {
      typingText.typeOnly();
    },
  }).to(typingTextSecondary, {
    yPercent: 0,
    opacity: 1,
    duration: 0.5,
    ease: "power3.out",
    delay: 6 * 0.2,
    onStart: () => {
      typingTextSecondary.txt = "";
      typingTextSecondary.wordIndex = 0;
      typingTextSecondary.isDeleting = false;
    },
    onComplete: () => {
      typingTextSecondary.typeOnly();
    },
  });
});
